var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6F7485",
    d: "M4.333 12.916h11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.833 1.997l4.086 4.086-7.333 7.332h1.415l6.625-6.625a1 1 0 000-1.414L10.54 1.29a1 1 0 00-1.414 0L1.374 9.042a1 1 0 000 1.415l2.959 2.958h1.414L2.08 9.75l7.752-7.752z",
    fill: "#6F7485"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.775,
    y: 1.347,
    width: 6.778,
    height: 4.501,
    rx: 0.5,
    transform: "rotate(45 9.775 1.347)",
    stroke: "#6F7485"
  })));
}
export default __webpack_public_path__ + "static/mail_clear.db5c2f58.svg";
export { SvgMailClear as ReactComponent };